<template>
  <div class="border-t cursor-pointer dark:border-dark-divider-border p-6" :class="[{ 'h-20': !expanded }]" @click="expanded = !expanded">
    <div class="flex gap-x-6 items-start">
      <div class="flex gap-x-2 items-center">
        <Avatar
          :first-name="email.meta_data.from[0].name ? email.meta_data.from[0].name.split(' ')[0] : email.meta_data.from[0].email"
          :last-name="email.meta_data.from[0].name.split(' ')[1]" />
        <div class="dark:text-white whitespace-nowrap">
          {{ email.meta_data.from[0].name ? email.meta_data.from[0].name : email.meta_data.from[0].email }}
        </div>
      </div>
      <div>
        <div :class="['overflow-hidden', { 'max-h-12': !expanded }]" v-html="clean_html" />
      </div>
      <div class="ml-auto whitespace-nowrap">
        {{ $moment(email.interaction_date).format("DD MMM  YYYY") }} {{ $t("at") }} {{ $moment(email.interaction_date).format("hh:mm A") }}
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "@/components/shared/Avatar.vue"

export default {
  components: { Avatar },
  props: {
    email: {
      type: Object,
      required: true
    },
    initiallyExpanded: {
      type: Boolean,
      required: false
    }
  },
  emits: [],
  data() {
    return {
      expanded: false,
      clean_html: null
    }
  },
  watch: {},

  created() {
    const htmlObject = document.createElement("div")
    htmlObject.innerHTML = this.email.description
    if (htmlObject.getElementsByClassName("gmail_quote")) {
      htmlObject.getElementsByClassName("gmail_quote")[0]?.remove()
    }
    this.clean_html = htmlObject.outerHTML
    if (this.initiallyExpanded) {
      this.expanded = true
    }
  },

  methods: {}
}
</script>
